import { useState } from "react";
import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Pagination from "@/components/feature/Pagination";
import { usePageMeta } from "@/hooks/usePageMeta";

const PAGE_SIZE = 5;

const sorted = [...news].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
);

export default function News() {
  const [page, setPage] = useState(1);

  usePageMeta(
    "影视资讯 - 后入影视网",
    "后入影视网影视资讯频道，提供最新影视新闻、票房动态、行业观察与深度影评，实时更新影视领域热门资讯。",
    "影视资讯,影视新闻,票房动态,行业观察,后入影视"
  );

  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const items = sorted.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  return (
    <div className="pb-16">
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视资讯" }]} />
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            影视资讯
          </h1>
          <p className="mt-2 max-w-2xl text-sm text-secondary-600">
            最新影视新闻、票房动态、行业观察与深度影评，一站掌握影视圈热点。
          </p>
        </div>
      </div>

      <div className="mx-auto w-full px-4 md:px-6">
        {items.length > 0 ? (
          <>
            <ul className="mt-6 flex flex-col gap-4">
              {items.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/news/${item.id}`}
                    className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 sm:flex-row md:p-5"
                  >
                    <span className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-100 sm:h-28 sm:w-44">
                      <img
                        src={item.cover}
                        alt={`${item.title} 资讯配图`}
                        title={`${item.title} 影视资讯`}
                        className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                      />
                    </span>
                    <span className="flex flex-1 flex-col">
                      <span className="flex items-center gap-3 text-xs text-secondary-500">
                        <span className="rounded bg-accent-50 px-2 py-0.5 text-accent-700">
                          {item.category}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-calendar-line"></i>
                          {item.date}
                        </span>
                      </span>
                      <span className="mt-2 text-base font-semibold text-foreground-950 group-hover:text-accent-600 md:text-lg">
                        {item.title}
                      </span>
                      <span className="mt-2 line-clamp-2 text-sm leading-relaxed text-secondary-600">
                        {item.summary}
                      </span>
                      <span className="mt-3 flex items-center gap-1 text-sm text-accent-600">
                        阅读全文
                        <i className="ri-arrow-right-s-line"></i>
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
            <Pagination
              page={currentPage}
              totalPages={totalPages}
              onChange={(next) => {
                setPage(next);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </>
        ) : (
          <div className="mt-10 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 py-20 text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-secondary-400">
              <i className="ri-newspaper-line text-3xl"></i>
            </span>
            <p className="mt-4 font-heading text-lg font-bold text-foreground-900">
              暂无资讯
            </p>
            <Link
              to="/"
              className="mt-5 flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}